import { DateTimeFormatter } from '../../formatters';
import { useAppSelector } from './store-hooks';

/**
 * For now this hook only wraps @see DateTimeFormatter so it will return the same instance but because it subscribes to the store it will trigger a React render.
 * @returns 
 */
export function useDateTimeFormatter() {
    // TODO: check if single selector with shallow equal comparator is quicker and more efficient than individual ones
    useAppSelector((x) => x.settings.timeDisplayZone);
    useAppSelector((x) => x.settings.timeDisplayFormat);
    useAppSelector((x) => x.settings.dateDisplayFormat);
    useAppSelector((x) => x.settings.dateDelimiter);
    useAppSelector((x) => x.settings.showDayWithTimes);

    // DateTimeFormatter is updated outside this hook
    return DateTimeFormatter;
}
